import React from 'react';
import AmeyoUploadNumbers from '../pages/AmeyoUtility/components/UploadNumbers';
import AllAgents from '../pages/AllAgents';
import Allocation from '../pages/AllocationServices';
import BulkUploadAndUploadHistory from '../pages/AllocationServices/BulkUpload';
import AvailabilityHistory from '../pages/AgentAvailability/components/AgentAvailabilityHistory/AvailabilityHistory';
import HrcRouter from '../pages/HrcRouter';
import Paramount from '@cp/pages/Paramount';
import EditStrategy from '@cp/pages/Paramount/EditStrategy';
import ViewStrategy from '@cp/pages/Paramount/ViewStrategy';
import ViewProducts from '@cp/pages/Paramount/Products/Viewproducts';
import Playground from '@cp/pages/Paramount/Playground';
import Segments from '@cp/pages/Paramount/Segments';
import Timelines from '@cp/pages/Paramount/Timelines';
import ViewTimelines from '../pages/Paramount/Timelines/ViewTimelines';
import CashCollectedCard from '../pages/Enach/enach';
import AgencyDetails from '../pages/AgencyManagement/AgencyDetails';
import SelfServeStateResetter from '@cp/pages/SelfServeStateResetter';
import AllocationPage from '../pages/AllocationServices/AllocationPage';
import AgencyAllocation from '../pages/AllocationServices/AgencyAllocation';
import { AllocationType, CaseType } from '../pages/AllAgents/UploadHistory/types.ts/types';
import AgencyCapping from '@cp/pages/AgencyCapping';
import AgencyUtils from '@cp/pages/AgencyUtils';
import AnomalyTracker from '../pages/AnomalyTracker';
import DashBoard from '../pages/DashboardV2/Dashboard';
import Approvals from '../pages/Approvals';
import Reports from '../pages/Reports';
import ViewReportStatus from '../pages/Reports/ViewReportStatus';
import Impersonation from '../pages/Impersonation';
import FieldAllocations from '../pages/FieldAllocations';
import PreviousAllocation from '../pages/FieldAllocations/components/PreviousAllocation/PreviousAllocation';
import AddressIngestion from '../pages/AddressIngestion';
import CaseExclusionExperiment from '../pages/FieldAllocations/components/CaseExclusionExperiment/CaseExclusionExperiment';
import ConfigureReports from '../pages/Reports/ConfigureReports';
import AllocationStatus from '../pages/AllocationServices/AllocationStatus';
import SystemAllocationStatus from '../pages/AllocationServices/AllocationStatus/SystemAllocationStatus';
import CiuAllocations from '../pages/CiuAllocations';
import CallAudit from '../pages/CallAudit';
import CallLimit from '../pages/CallLimit';

const Cases = React.lazy(() => import('../pages/Cases/components/Cases'));
const NotFound = React.lazy(() => import('../pages/404/NotFound'));
const ExternalDashboardSensei = React.lazy(() => import('../pages/ExternalDashboardSensei'));
const CsaCoordination = React.lazy(() => import('../pages/CsaCoordination'));
const CsaPerformanceDashboard = React.lazy(() => import('../pages/CsaPerformanceDashboard'));
const WhatsappChatbot = React.lazy(() => import('../pages/WhatsappChatbot/WhatsAppChatDashboard'));
const WhatsappChatbotSelected = React.lazy(
  () => import('../pages/WhatsappChatbot/WhatsAppChatDetail')
);

const CaseDetail = React.lazy(() => import('../pages/CaseDetails/components/CaseDetail'));
const PerformanceDashboard = React.lazy(
  () => import('src/pages/PerformanceDashboard/PerformanceDashboard')
);
const AgentAvailability = React.lazy(() => import('src/pages/AgentAvailability'));

const TeamLeadDashboard = React.lazy(() => import('src/pages/TeamLeadDashboard'));

const AmeyoUtility = React.lazy(() => import('../pages/AmeyoUtility'));
const LeaveManagement = React.lazy(() => import('../pages/LeaveManagement'));
const LiveLocationTracker = React.lazy(() => import('../pages/LiveLocationTracker'));
const Reallocation = React.lazy(() => import('../pages/Reallocation/components/Reallocation'));
const Sensei = React.lazy(() => import('../pages/sensei'));
const SenseiTele = React.lazy(() => import('../pages/SenseiTele'));
const GenerateAmeyoPassword = React.lazy(() => import('../pages/AmeyoGeneratePassword'));
const AgencyPincodeMapping = React.lazy(() => import('../pages/AgencyPincodeMapping'));

export const APP_ROUTES_PATHS_WITH_PATH_PARAM = {
  SENSEI: {
    daily_planning: '/sensei/daily_planning',
    overall_performance: '/sensei-external/overall_performance',
    field_governance: '/sensei-external/field_governance',
    tele_governance: '/sensei-external/tele_governance',
    external_daily_planning: '/sensei-external/daily_planning',
    map_view_allocation: '/sensei/map_view/allocation_view',
    map_view_live_location: '/sensei/live_location',
    external_map_view_allocation: '/sensei-external/map_view/allocation_view',
    external_map_view_live_location: '/sensei-external/map_view/live_location',
    external_visit_plan: '/sensei-external/visit_plan',
    overall_metric: '/sensei/overall_metric',
    overall_metric_v2: '/sensei/overall_metric_v2',
    visit_plan: '/sensei/visit_plan'
  },
  CSA_COORDINATION: {
    tasks_for_me: '/tickets/tasks',
    request_field_support: '/tickets/field_support'
  },
  ANOMALY_TRACKER: {
    open: '/anomaly/open',
    closed: '/anomaly/closed'
  },
  CSA_DASHBOARD: {
    csa: '/csa-performance/csa',
    dme: '/csa-performance/dme'
  },
  AGENCY_UTILITIES: {
    agency_capping: '/agency-utils/agency_capping',
    agency_pincode_mapping: '/agency-utils/agency_pincode_mapping'
  }
};
const APP_ROUTES = {
  CASES: {
    path: '/cases',
    element: <Cases />,
    exact: true
  },
  CASE_DETAIL: {
    // todo need to find a better solution
    path: '/cases/details/lan/:loanId/customer/:customerId/caseReferenceId/:caseReferenceId/caseBusinessVertical/:caseBusinessVertical/tab/:selectedTab',
    element: <CaseDetail />,
    exact: true
  },
  HR_DASHBOARD: {
    path: '/hrc',
    element: <HrcRouter />,
    exact: true
  },
  DASHBOARD: {
    path: '/calling-agent/dashboard',
    element: <DashBoard />,
    exact: true
  },
  CSA_COORDINATION: {
    path: '/tickets/:tabId',
    relativePath: APP_ROUTES_PATHS_WITH_PATH_PARAM.CSA_COORDINATION.tasks_for_me,
    element: <CsaCoordination />
  },
  ANOMALY_TRACKER: {
    path: '/anomaly/:tabId',
    relativePath: APP_ROUTES_PATHS_WITH_PATH_PARAM.ANOMALY_TRACKER.open,
    element: <AnomalyTracker />
  },
  PERFORMANCE_DASHBOARD: {
    path: '/performance-dashboard',
    element: <PerformanceDashboard />,
    exact: true
  },
  TEAM_LEAD_DASHBOARD: {
    path: '/team-lead-dashboard',
    element: <TeamLeadDashboard />
  },
  APPROVALS: {
    path: '/approvals',
    element: <Approvals />,
    exact: true
  },
  LIVE_LOCATION_TRACKER: {
    path: '/live-location-tracker',
    element: <LiveLocationTracker />
  },
  SENSEI_EXTERNAL: {
    path: '/sensei-external/:tabId/:subTabId?',
    relativePath: APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.external_daily_planning,
    element: <ExternalDashboardSensei />
  },
  CSA_DASHBOARD: {
    path: '/csa-performance/:tabId',
    relativePath: APP_ROUTES_PATHS_WITH_PATH_PARAM.CSA_DASHBOARD.csa,
    element: <CsaPerformanceDashboard />
  },
  REALLOCATION: {
    path: '/reallocation',
    element: <Reallocation />,
    exact: true
  },
  SENSEI: {
    path: '/sensei/:tabId/:subTabId?',
    relativePath: APP_ROUTES_PATHS_WITH_PATH_PARAM.SENSEI.daily_planning,
    element: <Sensei />
  },
  AGENT_AVAILABILITY: {
    path: '/agent-availability',
    element: <AgentAvailability />
  },
  AGENT_AVAILABILITY_HISTORY: {
    path: '/agent-availability/availability-history',
    element: <AvailabilityHistory />
  },
  AGENCY_PINCODE_MAPPING: {
    path: '/agency-pincode-mapping',
    element: <AgencyPincodeMapping />,
    exact: true
  },
  AGENCY_CAPPING: {
    path: '/agency-capping',
    element: <AgencyCapping />,
    exact: true
  },
  AGENCY_UTILITIES: {
    path: '/agency-utils/:tabId',
    relativePath: APP_ROUTES_PATHS_WITH_PATH_PARAM.AGENCY_UTILITIES.agency_capping,
    element: <AgencyUtils />
  },
  AMEYO_UTILITY: {
    path: '/ameyo-utility',
    element: <AmeyoUtility />,
    exact: true
  },
  GENERATE_AMEYO_PASSWORD: {
    path: '/ameyo-utility/generate-ameyo-password',
    element: <GenerateAmeyoPassword />,
    exact: true
  },
  AMEYO_UPLOAD_NUMBERS: {
    path: '/ameyo-utility/upload-numbers',
    element: <AmeyoUploadNumbers />,
    exact: true
  },
  LEAVE_MANAGEMENT: {
    path: '/leave-management',
    element: <LeaveManagement />
  },
  WHATSAPP_CHATBOT: {
    path: '/whatsapp-chatbot',
    element: <WhatsappChatbot />
  },
  WHATSAPP_CHATBOT_WITH_REFERENCE_ID: {
    path: '/whatsapp-chatbot/:referenceId',
    element: <WhatsappChatbotSelected />
  },
  SENSEI_TELE: {
    path: '/sensei-tele',
    element: <SenseiTele />,
    exact: true
  },
  NOT_FOUND: {
    path: '*',
    element: <NotFound />
  },
  TL_GENERATE_AMEYO_PASSWORD: {
    path: '/generate-ameyo-password',
    element: <GenerateAmeyoPassword />,
    exact: true
  },
  ALL_AGENTS: {
    path: '/all-agents',
    element: <AllAgents />,
    exact: true
  },
  ALLOCATION: {
    path: '/allocation',
    element: <AllocationPage />,
    exact: true
  },
  AGENTS_ALLOCATION: {
    path: '/allocation/agents',
    element: <Allocation />,
    exact: true
  },
  AGENCY_ALLOCATION: {
    path: '/allocation/agencies',
    element: <AgencyAllocation />,
    exact: true
  },
  FIELD_ALLOCATIONS: {
    path: '/allocation/field-allocations',
    element: <FieldAllocations />,
    exact: true
  },
  CIU_ALLOCATION: {
    path: '/allocation/ciu',
    element: <CiuAllocations />,
    exact: true
  },
  ALLOCATE_CASES_FOR_AGENCY: {
    path: '/allocate-cases/agencies',
    element: (
      <BulkUploadAndUploadHistory
        typeOfAllocation={AllocationType.Allocate}
        isAllocatingForAgency={true}
        caseType={CaseType.Agency}
      />
    ),
    exact: true
  },
  DEALLOCATE_CASES_FOR_AGENCY: {
    path: '/deallocate-cases/agencies',
    element: (
      <BulkUploadAndUploadHistory
        typeOfAllocation={AllocationType.Deallocate}
        isAllocatingForAgency={true}
        caseType={CaseType.Agency}
      />
    ),
    exact: true
  },
  ALLOCATE_CASES_FOR_AGENTS: {
    path: '/allocate-cases',
    element: (
      <BulkUploadAndUploadHistory
        typeOfAllocation={AllocationType.Allocate}
        caseType={CaseType.Agent}
      />
    ),
    exact: true
  },
  DEALLOCATE_CASES_FOR_AGENTS: {
    path: '/deallocate-cases',
    element: (
      <BulkUploadAndUploadHistory
        typeOfAllocation={AllocationType.Deallocate}
        caseType={CaseType.Agent}
      />
    ),
    exact: true
  },
  PARAMOUNT: {
    path: '/paramount',
    element: <Paramount />,
    exact: true
  },
  PARAMOUNT_EDIT_STRATEGY: {
    path: '/paramount/edit-strategy',
    element: <EditStrategy />,
    exact: true
  },
  PARAMOUNT_VIEW_STRATEGY: {
    path: '/paramount/view-strategy',
    element: <ViewStrategy />,
    exact: true
  },
  PARAMOUNT_PRODUCTS: {
    path: '/paramount/view-products',
    element: <ViewProducts />,
    exact: true
  },
  PARAMOUNT_TIMELINES: {
    path: '/paramount/view-timelines',
    element: <Timelines />,
    exact: true
  },
  PARAMOUNT_VIEW_TIMELINE: {
    path: '/paramount/view-timeline',
    element: <ViewTimelines />,
    exact: true
  },
  PARAMOUNT_PLAYGROUND: {
    path: '/paramount/playground',
    element: <Playground />,
    exact: true
  },
  PARAMOUNT_SEGMENTS: {
    path: '/paramount/view-segments',
    element: <Segments />,
    exact: true
  },
  ENACH: {
    path: '/calling-agent/enach',
    element: <CashCollectedCard />,
    exact: true
  },
  AGENCIES: {
    path: '/agencies',
    element: <AgencyDetails />,
    exact: true
  },
  SELF_SERVE_STATE_RESETTER: {
    path: '/self-server-state-resetter',
    element: <SelfServeStateResetter />,
    exact: true
  },
  REPORTS: {
    path: '/reports',
    element: <Reports />,
    exact: true
  },
  VIEW_REPORT_STATUS: {
    path: '/reports/view-report-status',
    element: <ViewReportStatus />,
    exact: true
  },
  IMPERSONATION: {
    path: '/impersonation',
    element: <Impersonation />,
    exact: true
  },
  PREVIOUS_ALLOCATION: {
    path: '/allocation/field-allocations/previous-month-allocation',
    element: <PreviousAllocation />,
    exact: true
  },
  ADDRESS_INGESTION: {
    path: '/address-ingestion',
    element: <AddressIngestion />,
    exact: true
  },
  CASE_EXCLUSION_EXPERIMENT: {
    path: '/case-exclusion-experiment',
    element: <CaseExclusionExperiment />,
    exact: true,
    featureFlag: 'allocationExperimentsAccessEnabled'
  },
  CONFIGURE_REPORTS: {
    path: '/reports/configure',
    element: <ConfigureReports />,
    exact: true
  },
  ALLOCATION_STATUS: {
    path: '/allocation-status',
    element: <AllocationStatus />,
    exact: true
  },
  SYSTEM_ALLOCATION_STATUS: {
    path: '/system-allocation-status',
    element: <SystemAllocationStatus />,
    exact: true
  },
  CALL_AUDIT: {
    path: '/call-audit',
    element: <CallAudit />,
    exact: true
  },
  CALL_LIMIT: {
    path: '/call-limit',
    element: <CallLimit />,
    exact: true
  }
};

export const LOGIN_PATH = '/login';

export const COSMOS_PATH = '/cosmos';
export const FIELD_AGENT_DOWNLOAD_PATH = '/field-agent-download';
export const CALLING_AGENT_DOWNLOAD_PATH = '/calling-agent-download';
export const DIALER_DOWNLOAD_PATH = '/dialer-download';

export const UPDATE_EXTENSION_DEMO_PATH = '/update-extension-demo';

export default APP_ROUTES;
